import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "custom-code" }

import Controller from './controller.vue';
  import { ref, inject, watchEffect, Ref, reactive, computed } from 'vue';
  import { ISnippet } from '@/types/snippet';
  import { request } from '@/utils';
  import { FormItem } from '@/types/form';

  export interface IForm {
    id?: number;
  }
  export interface IProps {
    props: IForm;
    modelValue?: boolean;
    injectData?: { [key: string]: any }
  }
  export interface IEmits {
    (event: 'update:modelValue', props: boolean): void;
    (event: 'change', props: IForm): void;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    props: null,
    modelValue: { type: Boolean },
    injectData: null
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit: emits }: { emit: ({
    (event: 'update:modelValue', props: boolean): void;
    (event: 'change', props: IForm): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    props: IForm;
    modelValue?: boolean;
    injectData?: { [key: string]: any }
  }

  
  

  const editorMode = inject('editorMode');
  const snippets: Ref<ISnippet[]> = inject('snippets', ref([]));

  const code = ref('');
  const form = reactive<IForm>({});
  const formList = computed(() => {
    const list: FormItem[] = [
      snippets.value.length && {
        label: 'Select code',
        type: 'select',
        key: 'id',
        required: false,
        options: snippets.value.map(item => ({ text: item.title, value: item.id }))
      }
    ].filter(Boolean) as FormItem[];
    return list;
  });
  const handleChange = (form: IForm) => {
    emits('change', form);
  };

  watchEffect(async () => {
    const id = props.props.id;
    if (id) {
      form.id = id;
      const { data } = await request.get(`custom_snippets/${id}`);
      code.value = data.html_content;
    } else {
      code.value = '';
    }
  });

return (_ctx: any,_cache: any) => {
  const _component_AppDynamicComponent = _resolveComponent("AppDynamicComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(editorMode))
      ? (_openBlock(), _createBlock(Controller, {
          key: 0,
          title: "Code",
          visible: __props.modelValue,
          "form-list": _unref(formList),
          form: _unref(form),
          "onUpdate:visible": _cache[0] || (_cache[0] = visible => emits('update:modelValue', visible)),
          onChange: handleChange
        }, null, 8, ["visible", "form-list", "form"]))
      : _createCommentVNode("", true),
    _createVNode(_component_AppDynamicComponent, {
      code: code.value,
      data: __props.injectData
    }, null, 8, ["code", "data"])
  ]))
}
}

})